import { render } from "./RelatedItems.vue?vue&type=template&id=f7c6899e&scoped=true&ts=true"
import script from "./RelatedItems.vue?vue&type=script&lang=ts"
export * from "./RelatedItems.vue?vue&type=script&lang=ts"

import "./RelatedItems.vue?vue&type=style&index=0&id=f7c6899e&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c6899e"]])

export default __exports__